import { BaseSectionCreator } from './baseSectionCreator';
import { IItemSection, ItemSection, SectionType } from '../itemSection';
import { Product } from '@/store/modules/product';
import store from '@/store';
import { ElementType } from '../element';
import { deskLegs } from '../legs/deskLegs';

export class DeskSectionCreator extends BaseSectionCreator {

    protected sections: IItemSection[] = [
        new ItemSection(SectionType.BODY_COLOR, 'kolorkorpusu', []),
        new ItemSection(SectionType.FRONT_COLOR, '', []),
        new ItemSection(SectionType.WALL_COLOR, '', []),
        new ItemSection(SectionType.LEGS, 'nóżki', []),
        new ItemSection(SectionType.HANDLES, '', []),
    ];

    constructor(
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public create(product: Product): IItemSection[] {
        this.applyLanguage();
        const furnitureShaders = store.getters.shaders.furniture;
        this.updateShaderSection(SectionType.BODY_COLOR, ElementType.BODY, furnitureShaders);
        this.updateFrontsSection(furnitureShaders);
        this.updateShaderSection(SectionType.WALL_COLOR, ElementType.WALL, furnitureShaders);
        this.updateLegsSection(product, deskLegs);
        this.updateHandlesSection();
        return this.sections;
    }

    protected applyLanguage(): void {
        this.getSectionByType(SectionType.BODY_COLOR).text = this.scenePreview.$t('bodyColor');
        this.getSectionByType(SectionType.FRONT_COLOR).text = this.scenePreview.$t('altFrontColor');
        this.getSectionByType(SectionType.WALL_COLOR).text = this.scenePreview.$t('wallColor');
        this.getSectionByType(SectionType.LEGS).text = this.scenePreview.$t('longLegs');
        this.getSectionByType(SectionType.HANDLES).text = this.scenePreview.$t('handles');
    }
}
